<div class="w-100 float-left" *ngIf='roleData'>
    <div class="w-100 float-left v-align relative b-b">
        <h5 class="medium float-left" *ngIf="type == 'CREATE'"> {{'createRoles' | translate}} </h5>
        <h5 class="medium float-left" *ngIf="type == 'EDIT'">{{'editRoles' | translate}} </h5>
        <div style="flex-grow: 1;"></div>
        <button class="btn btn-secondary float-right mb-2" name="backToR&P" (click)="rolesBack()"><i
                class="fa fa-arrow-left mr-sm-2"></i>{{'back' | translate}}
        </button>
    </div>
    <div class="w-50 float-left mt-3">
        <form action="">
            <div class="form-group">
                <label> {{'name' | translate}}
                    <span class="text-danger medium">*</span>
                </label>
                <input type="text" class="form-control" [(ngModel)]="roleData.name" name="nameInR&P" maxlength="100"/>
                <span class="info-text"> {{'Max' | translate}}. 100 </span>
            </div>
            <div class="form-group">
                <label> {{'code' | translate}}
                    <span class="text-danger medium">*</span>
                </label>
                <input type="text" class="form-control" [(ngModel)]="roleData.code" name="codeInR&P" maxlength="100"/>
                <span class="info-text"> {{'Max' | translate}}. 100 </span>
            </div>
            <div class="form-group">
                <label> {{'description' | translate}}
                    <span class="text-danger medium"></span>
                </label>
                <textarea class="form-control" rows="5" [(ngModel)]="roleData.description" name="descriptionInR&P"
                          maxlength="100"></textarea>
                <span class="info-text"> {{'Max' | translate}}. 100 </span>
            </div>
        </form>
    </div>
    <div class="w-100 float-left my-4">
        <h5 class="medium float-left w-100 mb-3"> {{'permissions' | translate}} </h5>
    </div>
    <div class="w-100 float-left text-13x">
        <div class="w-100 float-left" *ngFor="let operation of roleData.operations;index as i">
            <operation [operation]='operation' [i]='operation.operation' (selected)="selected($event)"></operation>
        </div>
    </div>

    <button class="btn btn-primary float-right" *ngIf="type == 'CREATE'" name="createInR&P" (click)="editOrSave()"
            [disabled]="buttonDisabled">{{'create' | translate}}
    </button>
    <button class="btn btn-primary float-right" *ngIf="type == 'EDIT'" name="updateInR&P" (click)="editOrSave()"
            [disabled]="buttonDisabled">{{'Update' | translate}}
    </button>
    <button class="btn btn-secondary float-right mr-4" name="cancelInR&P" (click)="rolesBack()">{{'cancel' |
        translate}}
    </button>
</div>


// WEBPACK FOOTER //
// ./src/app/tools/rolesAndPermission/createRolesAndPermission.html